(function() {

    var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";
    var isLogin    = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";

    var movingAuth = {
        init: function() {
            var self = this;

            vcui.require([
                'ui/imageFileInput', 'ui/validation'
            ], function() {
                self.setting();
                self.bindEvents();
                self.setCalendar();
            });
        },
        
        setting: function() {
            var self = this;

            self.$popupOpenButton = $('[data-btn-link=movingAuth]');
            self.$popup = $('#popup-moving-auth');
            self.$authSuccessPopup = $('#popup-moving-auth-success');
            self.$maskConfirmPopup = $('#popup-moving-mask-confirm');
            self.$authSubmitButton = self.$popup.find('[name=authSubmitButton]');
            self.$popupOpener = null;
            self.initImageFileInput();

            var register = { 
                anniversary: {
                    required: true
                },
                imageFile1: {
                    required: true
                } ,
                planEventId: {
                    required: true
                } ,
                certType: {
                    required: true
                } 
            }

            self.validation = new vcui.ui.CsValidation('#movingAuthForm', {register:register});
        },

        initImageFileInput: function() {
            var self = this;
            var options = {
                totalSize: 20 * 1024 * 1024,
                individualFlag: true,
                individual: {
                    size: 10 * 1024 * 1024
                },
                format: 'jpg|jpeg|png|JPG|JPEG|PNG',
                message: {
                    format: '10MB 이하의 JPEG, PNG 파일만 첨부 가능합니다.',
                    size: '첨부파일 크기는 10M 이하로 등록해 주세요.'
                },
                useMaskEditor: true,
                delCompleted: function() {
                    self.updateAuthButtonState();
                },
                maskCompleted: function() {
                    self.updateAuthButtonState();
                }
            };

            self.$popup.find('.ui_imageinput').each(function() {
                var $el = $(this);
                var instance = $el.vcImageFileInput('instance', false);
                if (instance) {
                    $.extend(instance.options, options);
                } else {
                    $el.vcImageFileInput(options);
                }
            });
        },

        bindEvents: function() {
            var self = this;

            // 이사인증하기 팝업
            self.$popupOpenButton.on('click', function(e) {
                self.$popupOpener = $(this);
                if (isLogin == "N") {
                    var obj = {title:'로그인이 필요합니다.<br>이동하시겠습니까?', cancelBtnName:'아니오', okBtnName:'네', ok: function () { self.goLogin(); }};
                    lgkorUI.confirm(null, obj, $(this)); //BTOCSITE-77414 > WA 전문가점검
                } else {
                    self.loginPlanEventAuthStatus();
                }
            });

            $("input:radio[name='chk-pri-moving']").on('change', function(e) {
                if($(this).val() == "N" ){
                    $('#popup-moving-privacy-confirm-button').addClass('disabled');
                }else{
                    $('#popup-moving-privacy-confirm-button').removeClass('disabled');
                }
            });

            $('#popup-moving-privacy-confirm-button').on('click', function(e) {
                if( $('#chk-pri-y-moving').is(':checked') ){
                    $('#chk-pri-agree-moving').prop("checked", true);
                    $('#popup-moving-privacy-close-button').click();
                    self.updateAuthButtonState();
                }else{
                    lgkorUI.alert("", {
                        title: '개인정보 수집 이용에 동의해 주세요.'
                    }, $('#chk-pri-y-moving'));
                }
            });

            $('#popup-moving-privacy-cancel-button,#popup-moving-privacy-close-button').on('click', function(e) {
                if( $('#chk-pri-y-moving').is(':checked') ){
                    $('#chk-pri-agree-moving').prop("checked", true); 
                }else{
                    $('#chk-pri-agree-moving').prop("checked", false); 
                }
                self.updateAuthButtonState();
            });

            $('#movingAuthForm').on('change input', function() {
                self.updateAuthButtonState();
            });

            $('#movingDateInput').on('calendarinsertdate', function() {
                self.updateAuthButtonState();
            });

            // 이사인증 저장
            self.$authSubmitButton.on('click', function(e) {
                var check = self.validation.getCheckValidate();
                var agree = $('#chk-pri-agree-moving').prop('checked');
                if (check && check.isSuccess && agree) {
                    self.$maskConfirmPopup.vcModal({opener: self.$authSubmitButton}).vcModal('open');
                }
            });

            // 마스킹 처리 확인 후 예 버튼
            self.$maskConfirmPopup.find('[data-role=ok]').on('click', function(e) {
                // 마스킹 확인 팝업이 완전히 닫힌 뒤 저장 (모달 z-index 꼬임 방지)
                self.$maskConfirmPopup.one('modalhidden', function() {
                    movingAuth.authSave();
                });
                self.$maskConfirmPopup.vcModal('hide');
            });
            // 마스킹 처리 확인 후 아니오 버튼
            self.$maskConfirmPopup.find('[data-role=cancel]').on('click', function(e) {
                self.$popup.vcModal('hide');
            });

            // 이사인증 success 후 확인 버튼
            self.$authSuccessPopup.find('[data-role=ok]').on('click', function(e) {
                // 이전 모달이 모두 닫힌 뒤 상담 팝업 오픈 (모달 z-index 꼬임 방지)
                $(document).one('modallastclose', function() {
                    embedConsultReserve.open(self.$popupOpener);
                });
                self.$popup.vcModal('hide');
            });
            // 이사인증 success 후 취소 버튼
            self.$authSuccessPopup.find('[data-role=cancel]').on('click', function(e) {
                self.$popup.vcModal('hide');
            });

        },

        // 이사인증 초기화
        initAuth: function() {
            var self = this;
            $('#movingDateInput').val('');
            $('#chk-pri-agree-moving').prop('checked', false);
            $('input[name=chk-pri-moving]').prop('checked', false);
            $('#popup-moving-privacy-confirm-button').addClass('disabled');
            self.$popup.find('.ui_imageinput').vcImageFileInput('removeAll');
            self.initImageFileInput();
            self.collapseAccordions();
            self.updateAuthButtonState();
        },

        // 인증 상태 조회
        loginPlanEventAuthStatus: function() {
            var self = this;
            var params = {certType: "mv"};
            var url = '/evt/api/event/retrievePlanAuthStatus.lgajax';

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(url, params, function(result) {
                lgkorUI.hideLoading();
                var data = (result.data && result.data.length > 0) ? result.data[0] : null;
                if (result.status == 'fail') {
                    if (data && data.loginYn == 'N') {
                        var obj = {
                            title: '로그인이 필요합니다.<br>이동하시겠습니까?',
                            cancelBtnName: '아니오',
                            okBtnName: '네',
                            ok: function () { self.goLogin(); }
                        };
                        lgkorUI.confirm(null, obj, self.$popupOpener);
                    } else {
                        lgkorUI.alert("", {
                            title: result.message ? result.message : '인증 정보 조회가 실패했습니다.<br>다시 시도해 주세요.'
                        }, self.$popupOpener);
                    }
                    return;
                }
                if (result.status == 'success') {
                    if (!data || !data.usrInfo) {
                        lgkorUI.alert("", {
                            title: result.message ? result.message : '인증 정보 조회가 실패했습니다.<br>다시 시도해 주세요.'
                        }, self.$popupOpener);
                        return;
                    }
                    self.initAuth();
                    $("#movingBuyerName").val(data.usrInfo.name);
                    $("#movingBuyerPhone").val(data.usrInfo.mobileNo);
                    self.$popup.vcModal({ opener: self.$popupOpener }).vcModal('open');
                }
            }, true);
        },

        // 이사인증 저장
        authSave: function() {
            var self = this;
            var ajaxUrl = $('#movingAuthForm').data('ajax');
            var param = self.validation.getAllValues();
            var formData = new FormData();
            for (var key in param) {
                formData.append(key, param[key]);
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxFileData(ajaxUrl, formData, function(result) {

                lgkorUI.hideLoading();
                if (result.status == 'success') {
                    self.$authSuccessPopup.vcModal({opener:self.$popupOpener}).vcModal('open');
                } else { 
                    lgkorUI.alert("", {title: result.message ? result.message : '이사 인증 신청에 실패했습니다.<br>다시 시도해 주세요.', ok: function(){ 
                    }}, self.$authSubmitButton);
                } 
            }, 'POST');
        },

        // 버튼 활성/비활성 (pink / dark-gray)
        updateAuthButtonState: function() {
            var self = this;
            var check = self.validation.getCheckValidate();
            var agree = $('#chk-pri-agree-moving').prop('checked');

            if (check && check.isSuccess && agree) {
                self.$authSubmitButton.removeClass('dark-gray').addClass('pink');
            } else {
                self.$authSubmitButton.removeClass('pink').addClass('dark-gray');
            }
        },

        // 펼침 영역 접기 (증빙서류, 반려대상)
        collapseAccordions: function() {
            var self = this;
            var $lists = self.$popup.find('.accordion-border-wrap .lists');

            // 기존에 열려 있는 아코디언은 모두 닫음
            $lists.filter('.on').each(function() {
                $(this).find('.ui_accord_toggle').trigger('click');
            });

            // 초기화 후에는 '증빙 서류 확인'만 열어 둠
            var $evidenceList = $lists.eq(0);
            if (!$evidenceList.hasClass('on')) {
                $evidenceList.find('.ui_accord_toggle').trigger('click');
            }
        },

        goLogin: function() {
            location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
        },

        setCalendar: function() {
            var nowDate = new Date();
            var postDate = new Date();
            var frstDay = new Date(nowDate.getFullYear(), nowDate.getMonth() , 1);
            postDate.setMonth(frstDay.getMonth() - 6);
            $('#movingCalButton').vcCalendar("setMinDate", postDate);
        },

    }

    window.movingAuth = movingAuth;

    $(document).ready(function() {
        // 이사인증 마크업이 있을 때만 초기화
        if ($('#movingAuthForm').length && $('[data-btn-link=movingAuth]').length) {
            movingAuth.init();
        }
    });

})();
